import { gql } from "@apollo/client";

const TESTIMONIALS_FRAGMENT = gql`
  fragment TestmonialSFragment on Testimonial {
    userName
    imageUrl
    userJobTitle
    comments
    userCompanyName
    userFiveStarRating
  }
`;

export default TESTIMONIALS_FRAGMENT;
